import { Logo } from "../../ui/components/Logo/Logo";
import { IconDoc } from "../../ui/components/icons/IconDoc";
import { IconTik } from "../../ui/components/icons/IconTik";
import { TwentyIcArrowLineLeft } from "../../ui/components/icons/TwentyIcArrowLineLeft";
import { t } from "i18next";
import { useState, useEffect } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { store } from "../../app/store";
import {
  MyOrderDetail,
  myOrderDetailSelector,
  getOrderAsync,
} from "../myorders/MyOrderDetailSlice";
import { WellnessBody } from "../Wellness/WellnessSlice/WellnessBodySlice";
import WellnessActivityTailComponent from "../../ui/components/ActivityTail/WellnessActivityTail";
import { ImageConfig } from "../../config/ImageConfig";
import { IconAddCalendar } from "../../ui/components/icons/IconAddCalendar";

export const WellnessBodyPaymentSuccess = () => {
  const wellnessBodyRoute = useMatch(
    "wellness/body/:wellnessBodyId/success/:bookingId"
  );

  const navigate = useNavigate();

  const [id, setId] = useState<number>(-1);
  const [wellnessBody, setWellnessBody] = useState<WellnessBody>();

  let myOrderDetail: MyOrderDetail = useAppSelector(
    (state) =>
      myOrderDetailSelector.selectById(state, id) ?? ({} as MyOrderDetail)
  );

  useEffect(() => {
    if (myOrderDetail.wellnessBody) {
      setWellnessBody(myOrderDetail.wellnessBody);
    }
  }, [myOrderDetail]);

  useEffect(() => {
    if (wellnessBodyRoute != null) {
      if (wellnessBodyRoute.params.bookingId) {
        setId(parseInt(wellnessBodyRoute.params.bookingId));
        store.dispatch(
          getOrderAsync(parseInt(wellnessBodyRoute.params.bookingId))
        );
        return;
      }
    }
  }, [wellnessBodyRoute]);

  return (
    <>
      <div className="paymentsuccess-wrapper">
        <div className="payment-everywhere-logo">
          <Logo width="186px" height="28px" />
        </div>
        <div className="paymentsuccess-content">
          <div className="paymentsuccess-frame">
            <div className="paymentsuccess-frame-firstsection">
              <div className="paymentsuccess-frame-firstsection-iconcontainer">
                <IconTik size={40} className={undefined}></IconTik>
              </div>
              <div className="paymentsuccess-frame-firstsection-text">
                <div className="paymentsuccess-frame-firstsection-firsttext">
                  {t("payments.success.firstText")}
                </div>
                <div className="paymentsuccess-frame-firstsection-subtitle">
                  {t("payments.success.thankYou")}
                </div>
              </div>
            </div>
            <div className="paymentsuccess-frame-secondsection">
              {wellnessBody && (
                <WellnessActivityTailComponent
                  activityTailType="BODY"
                  id={wellnessBody.id}
                  img={
                    wellnessBody.image
                      ? wellnessBody.image
                      : ImageConfig.BACKGROUND_DEFAULT_SERVICE
                  }
                  mode={wellnessBody.remotelyOrPresenceEnum}
                  title={wellnessBody.name}
                  typology={wellnessBody.typology}
                  isIndividual={wellnessBody.isIndividual}
                  arrow={false}
                />
              )}
            </div>
            <div className="paymentsuccess-frame-thirdsection">
              <div
                className="paymentsuccess-frame-thirdsection-firstbutton"
                onClick={() => {}}
              >
                <IconAddCalendar></IconAddCalendar>
                <div
                  className="paymentfailed-buttontext"
                  onClick={() => {
                    navigate("/wellness/body/myOrders/" + id);
                  }}
                >
                  {t("payments.success.buttonCalendar")}
                </div>
              </div>
              <div
                className="paymentsuccess-frame-thirdsection-secondbutton"
                onClick={() => {
                  navigate("/wellness/body/myOrders/" + id);
                }}
              >
                <IconDoc className={undefined}></IconDoc>
                <div className="paymentfailed-buttontext">
                  {t("payments.success.buttonOrder")}
                </div>
              </div>
              <div
                className="paymentsuccess-frame-thirdsection-thirdbutton"
                onClick={() => {
                  navigate("/wellness/body");
                }}
              >
                <TwentyIcArrowLineLeft
                  className={undefined}
                ></TwentyIcArrowLineLeft>
                <div className="paymentfailed-buttontext">
                  {t("payments.success.buttonServices")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WellnessBodyPaymentSuccess;
